<div id="historical-graph-view-container" *ngIf="model$ | async; let model">
  <div class="total-amount" matTooltip="Info about the action">
    <h2>{{ model.totalAmount | currency }}</h2>
    <h5>Balance as at {{ model.asAt | date : "dd/MM/yyyy" }}</h5>
  </div>

  <div>
    <div
      *ngIf="model.graphDescription"
      class="alert alert-info d-flex align-items-center balance-details"
    >
      <mat-icon class="mr-3">help_outline</mat-icon>
      <div
        [innerHtml]="sanitizer.bypassSecurityTrustHtml(model.graphDescription)"
      ></div>
    </div>

    <div class="btn-group" role="group" aria-label="Basic example">
      <button
        type="button"
        class="btn btn-light"
        (click)="updateOptions('1m')"
        [class.active]="(selectedFilter$ | async) == '1m'"
      >
        1M
      </button>
      <button
        type="button"
        class="btn btn-light"
        (click)="updateOptions('6m')"
        [class.active]="(selectedFilter$ | async) == '6m'"
      >
        6M
      </button>
      <button
        type="button"
        class="btn btn-light"
        (click)="updateOptions('1y')"
        [class.active]="(selectedFilter$ | async) == '1y'"
      >
        1Y
      </button>
      <button
        type="button"
        class="btn btn-light"
        (click)="updateOptions('all')"
        [class.active]="(selectedFilter$ | async) == 'all'"
      >
        All
      </button>
    </div>

    <!-- chart one -->
    <div class="apx-chart" #chart></div>

    <div class="d-flex flex-fill flex-column">
      <mat-icon
        class="help-icon d-flex align-self-end"
        matTooltip="Select the area on the graph below by dragging the dotted line to zoom into the period you would like to view in the chart above."
      >
        help_outline</mat-icon
      >
      <div id="chart-line2">
        <!-- chart two -->
        <div #chart2></div>
      </div>
    </div>
  </div>
  <div class="d-flex mt-3 mb-1 links">
    <app-button
      class="{{ 'BTN.historical-chart-view.viewStatement.class' | translate }}"
      *featuretoggle="viewOtherStatementsFeatureToggle"
      icon="east"
      color="{{ 'BTN.historical-chart-view.viewStatement.color' | translate }}"
      routerLink="/member-statements"
      title="View Statements"
    ></app-button>
    <app-button
      *featuretoggle="viewTransactionsFeatureToggle"
      icon="east"
      routerLink="/transaction-listing"
      title="View all transactions"
    ></app-button>
    <app-button
      *featuretoggle="lodgeCirtClaimFeatureToggle"
      icon="attach_money"
      routerLink="/cirt/lodge-claim"
      title="Make a CIRT Claim"
    ></app-button>
    <app-button
      *featuretoggle="jetcoClaimFeatureToggle"
      icon="attach_money"
      routerLink="/cirt/jetco-lodge-claim"
      title="Make a JETCO Claim"
    ></app-button>

    <!-- <a class="btn btn-primary flex-fill d-grid me-1" routerLink="/transaction-listing">View all transactions</a>
    <a class="btn btn-light flex-fill ms-1" routerLink="/member-statements">View Statements</a> -->
  </div>
</div>
